"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerStatusResponseToJSON = exports.ServerStatusResponseFromJSONTyped = exports.ServerStatusResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
function ServerStatusResponseFromJSON(json) {
    return ServerStatusResponseFromJSONTyped(json, false);
}
exports.ServerStatusResponseFromJSON = ServerStatusResponseFromJSON;
function ServerStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'server_version': !runtime_1.exists(json, 'server_version') ? undefined : json['server_version'],
        'status': json['status'],
    };
}
exports.ServerStatusResponseFromJSONTyped = ServerStatusResponseFromJSONTyped;
function ServerStatusResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'server_version': value.server_version,
        'status': value.status,
    };
}
exports.ServerStatusResponseToJSON = ServerStatusResponseToJSON;
//# sourceMappingURL=ServerStatusResponse.js.map